import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { Headquarter } from '../models/headquarter.model';
import { Stats } from '../models/stats.model';
import { UserStats, UserStatsRequest, UserStatsRiepilogo } from '../models/userstats.model';
import { BaseService } from './base.service';

export class UserService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getHeadquarters(id: number): Promise<Headquarter[]> {
		return this.mapResponse<Headquarter[]>(this.http.get(`/ws/user/${id}/headquarters`), Headquarter);
	}

	stats(request: UserStatsRequest): Promise<UserStats> {
		return this.mapResponse<UserStats>(this.http.post('/ws/user/operator/stats', classToPlain(request)));
	}

	globalStats(request: UserStatsRequest): Promise<UserStats> {
		return this.mapResponse<UserStats>(this.http.post('/ws/user/operators/stats', classToPlain(request)));
	}

	topstats(hqid: number): Promise<Stats[]> {
		return this.mapResponse<Stats[]>(this.http.post('/ws/user/operators/topstats', { hqid }));
	}

	fattoriniStats(hid: number): Promise<UserStatsRiepilogo[]> {
		return this.mapResponse<UserStatsRiepilogo[]>(this.http.get(`/ws/user/fattoriniglobaldaylystats/${hid}`), UserStatsRiepilogo);
	}

	printCompensi(oid: number): Promise<any> {
		return this.mapResponse(this.http.get(`/ws/user/operator/${oid}/payment`, { responseType: 'blob' }));
	}
}